module.exports = __webpack_public_path__ + "images/106_4096.jpg";